import React from 'react';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';
import { SvgGroupCenter } from 'apps/sigma2-ui/src/components/svg/SvgGroupCenter';
import { LevelDefinitionIconProps } from 'apps/sigma2-ui/src/components/level-definition-icon-props';

export const GreenCircleOutlineGroup: React.FC<LevelDefinitionIconProps> = (
  props,
) => {
  const strokeColor = toSvgColor('#6AC573', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <SvgGroupCenter baseWidth={10} baseHeight={11} {...props}>
        <circle
          cx="5"
          cy="5.10742"
          r="4"
          stroke={strokeColor}
          strokeWidth="2"
        />
      </SvgGroupCenter>
    </g>
  );
};

export const GreenCircleOutlineSvg: React.FC<LevelDefinitionIconProps> = (
  props,
) => {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <GreenCircleOutlineGroup {...props} />
    </svg>
  );
};
